import { render, staticRenderFns } from "./PDFLink.vue?vue&type=template&id=356e74b8&"
import script from "./PDFLink.vue?vue&type=script&lang=js&"
export * from "./PDFLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports